import api from '../lib/api'
import assign from 'lodash.assign'
import Cookie from 'js-cookie'
const name = 'privilege'

export default {
  name,
  namespaced: true,
  state: {
    bought: false,
    startDate: 0,
    endDate: 0,
    price: 499,
    cardId: '',
    discountPrice: 0,
    discountEndSeconds: 0,
    isNoticeShow: false
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async getPrivilegeInfo ({ commit }) {
      const res = await api.privilege.getPrivilegeInfo()()
      console.log(res)
      console.log(Cookie.get('isNoticeShow'))
      if (res.data.discountPrice < res.data.price && !Cookie.get('isNoticeShow')) {
        commit('set', { isNoticeShow: true })
      }
      commit('set', {
        bought: !!res.data.isBuy,
        price: res.data.price,
        discountPrice: res.data.discountPrice,
        discountEndSeconds: res.data.discountEndSeconds,
        startDate: res.data.startDate,
        endDate: res.data.endDate,
        cardId: res.data.courseId
      })
    },

    setBought ({ commit }, bought) {
      commit('set', { bought })
    },
    closeNotice ({ commit }) {
      commit('set', { isNoticeShow: false })
      Cookie.set('isNoticeShow', false )
    },
    init ({ dispatch }) {
      dispatch('getPrivilegeInfo')
    }
  }
}
